import { Mutation, MutationTree } from "vuex";
import { VodPageMutation, VodPageState, VoDType } from "@/components/VoD/types";
import { Movie, TvShow, VoDGenre } from "@/services/apiService/api.types";

export const mutations: MutationTree<VodPageState> &
  Record<VodPageMutation, Mutation<VodPageState>> = {
  [VodPageMutation.setViewedVodType](state, vodView: VoDType) {
    state.viewedVodType = vodView;
  },
  [VodPageMutation.setViewedVodIndex](state, vodIndex?: number) {
    state.viewedVodIndex = vodIndex;
  },
  [VodPageMutation.setMoviesByGenre](state, moviesByGenre: VoDGenre[]) {
    state.moviesByGenre = moviesByGenre;
  },
  [VodPageMutation.setTvShowsByGenre](state, tvShowsByGenre: VoDGenre[]) {
    state.tvShowsByGenre = tvShowsByGenre;
  },
  [VodPageMutation.setInfoModalVodId](state, vodId: number) {
    state.infoModalVodId = vodId;
  },
  [VodPageMutation.setShowVodInfoModal](state, show: boolean) {
    state.showVodInfoModal = show;
  },
  [VodPageMutation.setRefocusCardId](state, cardId: string) {
    state.refocusCardId = cardId;
  },
  [VodPageMutation.setClosePlayer](state, status: boolean) {
    state.closePlayer = status;
  },
  [VodPageMutation.setCardControls](state, controlsStatus: boolean) {
    state.cardControls = controlsStatus;
  },
  [VodPageMutation.setPlayedEpisodePos](
    state,
    pos:
      | {
          slideIndex: number;
          sliderIndex: number;
        }
      | undefined
  ) {
    state.playedEpisodePos = pos;
  },
  [VodPageMutation.setShowEpisodeInfoModal](state, show: boolean) {
    state.showEpisodeInfoModal = show;
  },
  [VodPageMutation.SetActiveEpisode](state, episode: null) {
    state.activeEpisode = episode;
  },
  [VodPageMutation.SetPromoVod](state, promoVoD: Movie | TvShow | null) {
    state.promoVoD = promoVoD;
  }
};
